module.exports = __webpack_public_path__ + "img/40_16.d9f486de.png";